import * as TypeGraphQL from "type-graphql";
export var SyncDirection;
(function (SyncDirection) {
    SyncDirection["ENGINE_TO_BACKEND"] = "ENGINE_TO_BACKEND";
    SyncDirection["BACKEND_TO_ENGINE"] = "BACKEND_TO_ENGINE";
    SyncDirection["BIDIRECTIONAL"] = "BIDIRECTIONAL";
})(SyncDirection || (SyncDirection = {}));
TypeGraphQL.registerEnumType(SyncDirection, {
    name: "SyncDirection",
    description: undefined,
});
//# sourceMappingURL=SyncDirection.js.map